(function () {
  function normalizeText(text) {
    return (text || "")
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function getReplacement(text) {
    const t = normalizeText(text).toLowerCase();

    const map = {
      "português (portugal)": "PT",
      "português": "PT",
      "english": "EN",
      "français": "FR",
      "francais": "FR"
    };

    return map[t] || null;
  }

  function replaceTextNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE) return;

    const original = normalizeText(node.nodeValue);
    const replacement = getReplacement(original);

    if (replacement && original !== replacement) {
      node.nodeValue = node.nodeValue.replace(original, replacement);
    }
  }

  function replaceIfNeeded(el) {
    if (!el) return;

    // Caso o elemento tenha texto + ícones/setas,
    // alteramos apenas os text nodes para não apagar a seta.
    Array.from(el.childNodes).forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        replaceTextNode(node);
      }
    });

    // Fallback para elementos que contenham só texto simples
    if (
      el.childNodes.length === 1 &&
      el.firstChild &&
      el.firstChild.nodeType === Node.TEXT_NODE
    ) {
      const currentText = normalizeText(el.textContent);
      const replacement = getReplacement(currentText);

      if (replacement && currentText !== replacement) {
        el.textContent = replacement;
      }
    }
  }

  function replaceLanguageLabels(root) {
    const scope = root || document;

    const selectors = [
      // Drawer / dropdown
      "#HeaderDrawerLanguageForm button",
      "#HeaderDrawerLanguageForm a",
      "#HeaderDrawerLanguageForm span",
      "#HeaderDrawerLanguageForm .localization-dropdown__item",

      // Header / selected language
      "#header-component dropdown-opener",
      "#header-component dropdown-opener button",
      "#header-component dropdown-opener span",
      "#header-component .header__localization-settings button",
      "#header-component .header__localization-settings a",
      "#header-component .header__localization-settings span",

      // Generic Shopify localization elements
      ".localization-form button",
      ".localization-form a",
      ".localization-form span",
      ".disclosure__list-wrapper button",
      ".disclosure__list-wrapper a",
      ".disclosure__list-wrapper span",
      "button.localization-dropdown__item",
      ".localization-dropdown__item"
    ];

    const elements = scope.querySelectorAll(selectors.join(","));

    elements.forEach(function (el) {
      replaceIfNeeded(el);
    });
  }

  function replaceAllTextNodes(root) {
    const scope = root || document.body;
    if (!scope) return;

    const walker = document.createTreeWalker(
      scope,
      NodeFilter.SHOW_TEXT,
      null
    );

    let node;
    while ((node = walker.nextNode())) {
      const parent = node.parentElement;
      if (!parent) continue;

      // Evita mexer em script/style
      const tagName = parent.tagName ? parent.tagName.toLowerCase() : "";
      if (tagName === "script" || tagName === "style") continue;

      replaceTextNode(node);
    }
  }

  function run() {
    replaceLanguageLabels(document);
    replaceAllTextNodes(document.body);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === "characterData") {
          replaceTextNode(mutation.target);
          return;
        }

        if (mutation.type === "childList") {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === Node.TEXT_NODE) {
              replaceTextNode(node);
            } else if (node.nodeType === Node.ELEMENT_NODE) {
              replaceIfNeeded(node);
              replaceLanguageLabels(node);
              replaceAllTextNodes(node);
            }
          });
        }
      });

      // Garantia extra para estados reconstruídos pelo tema
      replaceLanguageLabels(document);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();